import React from 'react';
import { useIntl } from 'react-intl';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Dialog from '@components/2-molecules/Dialog';
import { DialogBody, MarkdownContent } from './SkillInfoDialog.styled';

const REMARK_PLUGINS = [remarkGfm];

const mdComponents = {
  a: ({ href, children }: { href?: string; children?: React.ReactNode }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
};

interface SkillInfoDialogProps {
  show: boolean;
  onClose: () => void;
  title: string;
  content: string;
}

const SkillInfoDialog: React.FC<SkillInfoDialogProps> = ({ show, onClose, title, content }) => {
  const intl = useIntl();

  if (!show) return null;

  return (
    <Dialog
      show={show}
      headerTitle={title}
      onClose={onClose}
      onCloseIconButtonClick={onClose}
      primaryButtonLabel={intl.formatMessage({
        id: 'marketplace.skillInfo.close',
        defaultMessage: 'Close',
      })}
      onPrimaryButtonClick={onClose}
      closeOnEscape
      closeOnClickOutside
    >
      <DialogBody>
        <MarkdownContent>
          <ReactMarkdown remarkPlugins={REMARK_PLUGINS} components={mdComponents}>
            {content}
          </ReactMarkdown>
        </MarkdownContent>
      </DialogBody>
    </Dialog>
  );
};

export default SkillInfoDialog;
